module.exports = __webpack_public_path__ + "img/OBUNoOrder_06.8adba3f5.png";